module.exports = __webpack_public_path__ + "img/Magic-Glue-584x584.73710085.webp";